import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import "../../../src/stylecss/mainpage.css";
import "swiper/css";
import MainLogo from "../../assets/boj-images/dark_boj.png";
import backgroundImage from "../../assets/boj-images/new_side_banner.jpeg";
import "animate.css/animate.min.css";
import { message } from "antd";
import { compressImage } from "../../utils/compressImage";
import useFetchData from "../../common/useFetchData";
import CommonFileUploader from "../../common/CommonFileUploader";
import { validateImage as validateImageQuality } from '../../utils/ImageValidation';
import PrintPage from "./PrintPage";
import useBranding from "../../hooks/useBranding";
const categoriesList = [
    "Gold Jewellery",
    "Lightweight Diamonds",
    "Open Polki",
    "Bridesmaid Diamonds",
    "Gemstone Jewellery",
    "Loose Stones",
];
const allowedTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    // "image/heif",
    // "image/heic"
];

const styles = {
    imageDiv: {
        marginTop: "8px",
        width: "100%",
        padding: "10px",
        height: "200px",
        border: "1px solid #ddd",
        borderRadius: "6px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fafafa",
    },

    previewImg: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },

    fileLabel: {
        overflow: "hidden",
        height: "42px",
    },

    clipImg: {
        height: "20px",
        width: "auto",
        marginRight: "8px",
    },
};

const NewVisitorForm = () => {

    const { logoUrl, backgroundUrl } = useBranding();

    const [show, setShow] = useState(true);

    const { barcode } = useParams();
    const isBuyerFlow = Boolean(barcode);
    const lockExhibitorFields = isBuyerFlow;
    const [memberType, setMemberType] = useState(null);
    const disabledExhibitor = isBuyerFlow;





    const [category, setCategory] = useState("visitor");
    const [companyName, setCompanyName] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const navigate = useNavigate();
    const [emailError, setEmailError] = useState("");
    const [CompanyEmailError, setCompanyEmailError] = useState('')
    const [CompanyNumberError, setCompanyNumberError] = useState('')

    const [showError, setShowError] = useState("");
    const handleClose = () => setShow(false);
    const [registrationDate, setRegistrationDate] = useState("");
    const [duplicateError, setDuplicateError] = useState(null);
    const { showData, loading: visibilityLoading, error } = useFetchData();
    const [showSuccessPage, setShowSuccessPage] = useState(false);
    const [gst_data_present, setGst_data_present] = useState(null);
    //const [gst_certificate, setGstCertificate] = useState();


    const [storeImage, setStoreImage] = useState();
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [storeName, setStoreName] = useState("");
    const [companyEmail, setCompanyEmail] = useState("");
    const [companyAddress, setCompanyAddress] = useState('');
    const [companyNumber, setCompanyNumber] = useState("");
    const [zip, setZip] = useState('');
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [visitorFirstName, setVisitorFirstName] = useState('');
    const [visitorLastName, setVisitorLastName] = useState('');
    const [visitorMobileNo, setVisitorMobileNo] = useState("");
    const [visitorEmailId, setVisitorEmailId] = useState("");
    const [photo, setPhoto] = useState();
    const [idProofFront, setIDProofFront] = useState();
    const [idProofBack, setIDProofBack] = useState();
    const [photoLoading, setPhotoLoading] = useState(false);
    const [idFrontLoading, setIdFrontLoading] = useState(false);
    const [idBackLoading, setIdBackLoading] = useState(false);
    const [storeImgLoading, setStoreImgLoading] = useState(false);
    const [visitingCardLoading, setVisitingCardLoading] = useState(false);
    const [gst_number, setGst_number] = useState("");
    const [visitingCard, setVisitingCard] = useState("");
    const [selectedShow, setSelectedShow] = useState("");
    const [lastEventAttendedAs, setLastEventAttendedAs] = useState("");
    const [lastEventRegistrationMode, setLastEventRegistrationMode] = useState("");
    const [isOldVisitor, setIsOldVisitor] = useState(false);


    const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    function checkRegex(input) {
        return regex.test(input);
    }

    function convertToUpperCase(input) {
        return input.replace(/[a-z]/gi, (char) => char.toUpperCase());
    }

    const validateImage = async (e, setState, setUploadLoading, imageType) => {
        console.log("=== DEBUG START ===");
        console.log("1. Image type parameter:", imageType);

        const file = e.target.files[0];
        if (!file) {
            console.log("No file selected");
            return;
        }

        console.log("2. File info:", file.name, file.size, "bytes", file.type);

        setUploadLoading(true);

        try {
            const fileName = file.name.toLowerCase();
            const fileType = file.type;

            const isValidMime = allowedTypes.includes(fileType);
            const isValidExtension =
                fileName.endsWith(".jpg") ||
                fileName.endsWith(".jpeg") ||
                fileName.endsWith(".png");

            if (!isValidMime && !isValidExtension) {
                console.log("3. File type validation failed");
                message.error("Only JPG, JPEG, PNG images are allowed");
                e.target.value = "";
                return;
            }



            console.log("7. Validation passed!");

            let updatedFile = file;

            if (file.size > 1 * 1024 * 1024) {
                console.log("8. Compressing image...");
                updatedFile = await compressImage(file, 1);
            }

            setState(updatedFile);
            message.success("Image uploaded successfully!");

        } catch (err) {
            console.error("9. validateImage error:", err);
            message.error("Something went wrong. Try again.");
        } finally {
            setUploadLoading(false);
            console.log("=== DEBUG END ===");
        }
    };
    const resetGstDependentFields = () => {
        setCompanyAddress("");
        setCity("");
        setZip("");
        setCountry("");
        setCompanyName("");
        setState("");
        setStoreName("");
        setCompanyEmail("");
        setCompanyNumber("");
        setStoreImage("");
        setVisitingCard("");
        setDuplicateError(false);
        setGst_data_present(null);
    };

    const handleGstNumberChange = (e) => {

        let value = e.target.value.toUpperCase();

        value = value.replace(/[^A-Z0-9]/g, "");

        if (value.length > 15) return;

        for (let i = 0; i < value.length; i++) {
            const ch = value[i];
            const pos = i + 1;

            if (pos <= 2 && !/[0-9]/.test(ch)) return;
            if (pos > 2 && pos <= 7 && !/[A-Z]/.test(ch)) return;
            if (pos > 7 && pos <= 11 && !/[0-9]/.test(ch)) return;
            if (pos === 12 && !/[A-Z]/.test(ch)) return;
            if (pos === 13 && !/[1-9A-Z]/.test(ch)) return;
            if (pos === 14 && ch !== "Z") return;
            if (pos === 15 && !/[0-9A-Z]/.test(ch)) return;
        }

        setGst_number(value);

        if (value === "") {
            setShowError("Please enter GST");
            resetGstDependentFields();
            return;
        }

        if (value.length === 15 && !checkRegex(value)) {
            setShowError("Provide Valid GSTIN");
            resetGstDependentFields();
            return;
        }
        setShowError("");
    };





    const getImagePreviewUrl = (img) => {
        if (!img) return "";
        if (typeof img === "string") {
            if (img.startsWith("http://") || img.startsWith("https://") || img.startsWith("data:")) {
                return img;
            }
            const baseUrl = (process.env.REACT_APP_IMAGE_URL || process.env.REACT_APP_API_END_POINT || "https://crm.thebojshow.com/media").replace(/\/api\/?$/, "").replace(/\/+$/, "");
            const cleanImg = img.startsWith("/") ? img.slice(1) : img;
            if (baseUrl.endsWith("/media")) {
                return `${baseUrl}/${cleanImg}`;
            }
            return `${baseUrl}/public/media/${cleanImg}`;
        }
        if (img instanceof File || img instanceof Blob) {
            try {
                return URL.createObjectURL(img);
            } catch {
                return "";
            }
        }
        return "";
    };

    const getFileNameDisplay = (img) => {
        if (!img) return "Select File";
        if (typeof img === "string") return img.split('/').pop();
        if (img?.name) return img.name;
        return "Select File";
    };

    useEffect(() => {
        console.log("hello i am here to see the test daeeed", gst_number.length);
        if (isBuyerFlow) return;

        if (gst_number.length === 15 && checkRegex(gst_number)) {
            axios
                .get(
                    `${process.env.REACT_APP_API_END_POINT}/check-gst-validation/${gst_number}`
                )
                .then((resData) => {
                    console.log("gst find or not", resData.data);
                    const d = resData.data;
                    if (d?.flag === false) {
                        setShowError(d.message);
                        resetGstDependentFields();
                        return;
                    }
                    setGst_data_present(d);
                    setShowError("");

                    if (d.isOldCompany) {
                        if (d.company) setCompanyName(d.company);
                        if (d.store_name) setStoreName(d.store_name);
                        if (d.company_email) setCompanyEmail(d.company_email);
                        if (d.company_number) setCompanyNumber(d.company_number);
                        if (d.address) setCompanyAddress(d.address);
                        if (d.city) setCity(d.city);
                        if (d.state) setState(d.state);
                        if (d.country) setCountry(d.country);
                        if (d.pincode) setZip(d.pincode);
                        if (d.store_image) setStoreImage(d.store_image);
                        if (d.visiting_card) setVisitingCard(d.visiting_card);
                        if (d.jewellery_categories && d.jewellery_categories.length > 0) {
                            setSelectedCategories(d.jewellery_categories);
                        }
                    } else {
                        if (d.company) setCompanyName(d.company);
                        if (d.address) setCompanyAddress(d.address);
                        if (d.city) setCity(d.city);
                        if (d.pincode) setZip(d.pincode);
                        if (d.state) setState(d.state);
                        setCountry("India");
                        if (d.company) setStoreName(d.company);
                    }
                })
                .catch((err) => {
                    console.log("gst fetch validation ");
                    setShowError("Facing Problem While Fetching Error");
                    resetGstDependentFields();
                });
        }
    }, [gst_number]);

    const handlePhoto = (e) => validateImage(e, setPhoto, setPhotoLoading, "photo");

    const handleIDFront = (e) => validateImage(e, setIDProofFront, setIdFrontLoading, "id_proof_front");

    const handleIDBack = (e) => validateImage(e, setIDProofBack, setIdBackLoading, "id_proof_back");

    const handleStoreImage = (e) => validateImage(e, setStoreImage, setStoreImgLoading, "store_image");

    const handleVistingCard = (e) => validateImage(e, setVisitingCard, setVisitingCardLoading, "visiting_card");

    function validateGstNumber(gst_number) {
        // If gst_number is not empty, then perform the checks
        if (gst_number && (gst_number.length !== 15 || !checkRegex(gst_number))) {
            return false;
        }
        // If gst_number is empty, skip the checks and return true
        return true;
    }
    const isValid = validateGstNumber(gst_number);
    const handleSubmit = () => {
        if (!storeName) {
            message.error("Store Name is mandatory");
        } else if (!companyName) {
            message.error("Company Name is mandatory");
        } else if (!companyEmail) {
            message.error("Company Email is mandatory");
        } else if (!gst_number) {
            message.error("Gst Number is mandatory");
        } else if (!visitorFirstName) {
            message.error("First Name is mandatory");
        } else if (!visitorLastName) {
            message.error("Last Name is mandatory");
        } else if (!isValid) {
            message.error("Fill Valid Gst Number");
            setIsLoading(false);
        } else if (!visitorMobileNo) {
            message.error("Mobile No. is mandatory");
        } else if (visitorMobileNo.length !== 10) {
            message.error("Please Enter 10 Digit Mobile Number");
            setIsLoading(false);
            return;
        } else if (!visitorEmailId) {
            message.error("Email is mandatory");
        } else if (!companyAddress) {
            message.error("Address is mandatory");
        } else if (!city) {
            message.error("City is mandatory");
        } else if (!state) {
            message.error("State is mandatory");
        } else if (!zip) {
            message.error("zip is mandatory");
        } else if (!country) {
            message.error("Country is mandatory");
        } else if (!storeImage) {
            message.error("Store Image is Mandatory");
        } else if (!photo) {
            message.error("Photo is mandatory");
        } else if (!idProofFront) {
            message.error("ID Proof Front is mandatory");
        } else if (!idProofBack) {
            message.error("ID Proof Back is mandatory");
        } else if (!selectedShow) {
            message.error("Show is mandatory");
        }
        else {
            setIsLoading(true);
            const formData = new FormData();
            //   formData.append("mobile_number", number);
            //   formData.append("visitor_name", visitorName);

            //   //formData.append("gst_certicate",gst_certificate);
            //   formData.append("gst_number", gst_number);
            //   formData.append("visiting_as", visiting_as);
            //   // formData.append("invited_exhibitor_id", invitedByCompany.value);
            //   formData.append("category", category);
            //   formData.append("email", email);
            formData.append("company_name", companyName);
            formData.append("store_name", storeName);
            formData.append("company_email", companyEmail);
            formData.append("company_number", companyNumber);
            formData.append("gst_number", gst_number);
            formData.append("city", city);
            formData.append("state", state);
            formData.append("country", country);
            formData.append("zip_code", zip);
            formData.append("company_address", companyAddress);
            formData.append("store_image", storeImage);
            formData.append("jewellery_categories", selectedCategories);
            formData.append("show", selectedShow);
            formData.append("visitor_first_name", visitorFirstName);
            formData.append("visitor_last_name", visitorLastName);
            formData.append("visitor_mobile_no", visitorMobileNo);
            formData.append("visitor_email", visitorEmailId);
            formData.append("last_event_attended_as", lastEventAttendedAs);
            formData.append("last_event_registration_mode", lastEventRegistrationMode);
            formData.append("visiting_card", visitingCard);
            formData.append("photo", photo);
            formData.append("id_proof_front", idProofFront);
            formData.append("id_proof_back", idProofBack);
            Array.from(formData.entries()).forEach(e => {
                console.log(e);
            });

            axios
                .post(
                    `${process.env.REACT_APP_API_END_POINT}/visitor-registration`,
                    formData
                )
                .then((res) => {
                    const value = res.data.message;
                    if (value === "Buyer" || value === "Visitor") {
                        message.error(`This Person Is Allready Presented As ${value}`);
                    } else {
                        setShowSuccessPage(true);
                        setVisitorEmailId(value.email);
                        localStorage.setItem("barcode", res.data?.data?.barcode);
                        // setVisitorListData(value.barcode);
                        setVisitorMobileNo(value.mobile_number);
                        setRegistrationDate(moment(value.createdAt).format("MMM Do YY"));
                        setShow(false);
                        setSuccessMessage(true);
                        setIsLoading(false);
                        setCompanyNumber("");
                    }
                    setIsLoading(false); // this will always stop loader
                })
                .catch((err) => {
                    console.error("Registration error:", err);

                    message.error(
                        err.response?.data?.message || "Registration failed. Please try again later."
                    );

                    setIsLoading(false); //  stop loader on error
                });
        }
    };


    const handleCompanyName = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setCompanyName(alphabetOnlyValue);
    }
    const handleFirstNameChange = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setVisitorFirstName(alphabetOnlyValue);
    };
    const handleLastNameChange = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setVisitorLastName(alphabetOnlyValue);
    };
    const handleStoreNameChange = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setStoreName(alphabetOnlyValue);
    }
    const handleCity = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setCity(alphabetOnlyValue);
    };

    const handleVisitorEmailChange = (e) => {
        const value = e.target.value;
        setVisitorEmailId(value);
        setEmailError("");
    };

    const handleVisitorEmailBlur = () => {
        if (!visitorEmailId) {
            setEmailError("");
            return;
        }
        const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if (!emailPattern.test(visitorEmailId)) {
            setEmailError("Invalid email format");
        } else {
            setEmailError("");
        }
    };

    const handleCompanyEmailChange = (e) => {
        const value = e.target.value;
        setCompanyEmail(value);
        setCompanyEmailError("");
    };

    const handleCompanyEmailBlur = () => {
        if (!companyEmail) {
            setCompanyEmailError("");
            return;
        }
        const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if (!emailPattern.test(companyEmail)) {
            setCompanyEmailError("Invalid email format");
        } else {
            setCompanyEmailError("");
        }
    };



    const handleVisitorMobileNoChange = (e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, "");
        setDuplicateError(null)
        setVisitorMobileNo(numericValue);

        if (numericValue.length >= 10 && numericValue.length <= 15) {
            axios
                .get(
                    `${process.env.REACT_APP_API_END_POINT}/check-is-number/${numericValue}/visitor`
                )
                .then(({ data }) => {
                    console.log("[Frontend check-is-number]", data);
                    if (data.inUse || data.message === "vip") {
                        setDuplicateError(data.message === "vip" ? "vip" : "true");
                        setIsOldVisitor(false);
                    } else {
                        setDuplicateError(null);
                        if (data.isOldVisitor && data.oldVisitorData) {
                            setIsOldVisitor(true);
                            const ov = data.oldVisitorData;
                            if (ov.first_name) setVisitorFirstName(ov.first_name);
                            if (ov.last_name) setVisitorLastName(ov.last_name);
                            if (ov.email) setVisitorEmailId(ov.email);
                            if (ov.photo) setPhoto(ov.photo);
                            if (ov.id_proof_front) setIDProofFront(ov.id_proof_front);
                            if (ov.id_proof_back) setIDProofBack(ov.id_proof_back);
                            if (ov.store_image && !storeImage) setStoreImage(ov.store_image);
                            if (ov.visiting_card && !visitingCard) setVisitingCard(ov.visiting_card);
                            if (ov.last_event_attended_as) setLastEventAttendedAs(ov.last_event_attended_as);
                            if (ov.last_event_registration_mode) setLastEventRegistrationMode(ov.last_event_registration_mode);
                        } else {
                            setIsOldVisitor(false);
                        }
                    }
                });
        } else {
            setIsOldVisitor(false);
        }
    };

    const handleCompanyNumberChange = (e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, "");
        setCompanyNumber(numericValue);
        setCompanyNumberError(null)

        if (numericValue.length >= 10) {
            axios
                .get(
                    `${process.env.REACT_APP_API_END_POINT}/check-is-number/${numericValue}/visitor`
                )
                .then(({ data }) => {
                    if (data.inUse) {
                        setCompanyNumberError(data.message === "vip" ? "vip" : "true");
                    } else {
                        setCompanyNumberError(null);
                    }
                });
        }
    }

    //   useEffect(() => {
    //     axios
    //       .get(`${process.env.REACT_APP_API_END_POINT}/exhibitor-lists-data`)
    //       .then((resData) => {
    //         setComapnyList(resData.data.data);
    //       });
    //   }, []);
    return (
        <>
            <div>
                <div className="container-fluid">
                    <div className="row vh-100">
                        <div className="col-lg-5 col-md-12 d-lg-block p-0 img-col" style={{ position: "fixed" }}>

                            <img
                                src={backgroundUrl || backgroundImage}
                                alt="Placeholder"

                                className="img-fluid vh-100 w-60 top-img px-3 p-lg-5"
                            />
                        </div>

                        <div
                            className="col-lg-7 col-md-12 d-flex justify-content-center align-items-center form-col"
                            style={{
                                position: "absolute",
                                right: "0px",
                                borderLeft: "2px solid #e5e5e5"
                            }}
                        >


                            {showSuccessPage ? (
                                <>
                                    {" "}
                                    <PrintPage
                                        barcode={localStorage.getItem("barcode")}
                                        text={"Your registration is successfully completed."}
                                    />
                                </>
                            ) : (
                                <form className="w-100 px-4">
                                    <div className="text-aling-center">

                                        <img
                                            src={logoUrl || MainLogo}
                                            alt={process.env.REACT_APP_ORGANIZER_NAME}
                                            className="logo-img"
                                            style={{
                                                height: "250px",
                                                width: "280px",
                                                objectFit: "contain",
                                                display: "flex",
                                                margin: "0px auto 10px",
                                            }}
                                        />


                                        <h4
                                            className="text-center mb-3"
                                            style={{ marginTop: "15px" }}
                                        >
                                            Visitor Registration Form
                                        </h4>
                                    </div>
                                    {/* Form Inputs */}

                                    {visibilityLoading ? (
                                        <div className="w-100 p-2">
                                            <style>{`
                                                @keyframes skeletonShimmer {
                                                    0% { background-position: -200px 0; }
                                                    100% { background-position: 200px 0; }
                                                }
                                                .skeleton-box {
                                                    background: #e8e8e8;
                                                    background-image: linear-gradient(90deg, #e8e8e8 0px, #f5f5f5 40px, #e8e8e8 80px);
                                                    background-size: 300px 100%;
                                                    animation: skeletonShimmer 1.5s infinite linear;
                                                    border-radius: 4px;
                                                }
                                            `}</style>
                                            <div className="mb-4">
                                                <div className="skeleton-box mb-2" style={{ width: "120px", height: "18px" }}></div>
                                                <div className="d-flex gap-4">
                                                    <div className="skeleton-box" style={{ width: "90px", height: "22px", borderRadius: "12px" }}></div>
                                                    <div className="skeleton-box" style={{ width: "90px", height: "22px", borderRadius: "12px" }}></div>
                                                    <div className="skeleton-box" style={{ width: "90px", height: "22px", borderRadius: "12px" }}></div>
                                                </div>
                                            </div>
                                            <div className="row g-3">
                                                {[1, 2, 3, 4, 5, 6].map((i) => (
                                                    <div key={i} className="col-lg-6 col-12 mb-3">
                                                        <div className="skeleton-box mb-2" style={{ width: "40%", height: "16px" }}></div>
                                                        <div className="skeleton-box" style={{ width: "100%", height: "38px" }}></div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="mt-4 col-12">
                                                <div className="skeleton-box w-100" style={{ height: "45px", borderRadius: "4px" }}></div>
                                            </div>
                                        </div>
                                    ) : showData && showData.visitor === "active" ? (
                                        <div className="row">
                                            <div className="row">
                                                <div className="col-12 mb-3">
                                                    <label className="fw-bold fs-5 mb-2 d-block">
                                                        Show <font color="#FF0000">*</font>
                                                    </label>
                                                    <div className="d-flex align-items-center gap-4 mt-2">
                                                        <label className="d-flex align-items-center gap-2 me-4 cursor-pointer">
                                                            <input
                                                                type="radio"
                                                                name="show_option"
                                                                value="Hyderabad"
                                                                checked={selectedShow === "Hyderabad"}
                                                                onChange={(e) => setSelectedShow(e.target.value)}
                                                            />
                                                            <span>Hyderabad</span>
                                                        </label>
                                                        <label className="d-flex align-items-center gap-2 me-4 cursor-pointer">
                                                            <input
                                                                type="radio"
                                                                name="show_option"
                                                                value="Delhi"
                                                                checked={selectedShow === "Delhi"}
                                                                onChange={(e) => setSelectedShow(e.target.value)}
                                                            />
                                                            <span>Delhi</span>
                                                        </label>
                                                        <label className="d-flex align-items-center gap-2 cursor-pointer">
                                                            <input
                                                                type="radio"
                                                                name="show_option"
                                                                value="Both"
                                                                checked={selectedShow === "Both"}
                                                                onChange={(e) => setSelectedShow(e.target.value)}
                                                            />
                                                            <span>Both</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        Gst Number <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Gst Number"
                                                        value={gst_number}
                                                        className="form-control my-2"
                                                        disabled={
                                                            lockExhibitorFields ||
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true"
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true"
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        onChange={handleGstNumberChange}
                                                    />
                                                    {showError && (
                                                        <p className="text-danger">{showError}</p>
                                                    )}
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        Company Name <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Company Name"
                                                        className="form-control my-2"
                                                        disabled={
                                                            lockExhibitorFields ||
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.company
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.company
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={companyName}
                                                        onChange={(e) => {
                                                            handleCompanyName(e);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 mb-3">
                                                    <label className="fw-bold">
                                                        Store Name <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Store Name"
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true"
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true"
                                                        }
                                                        value={storeName}
                                                        className="form-control my-2"
                                                        onChange={(e) => {
                                                            handleStoreNameChange(e);
                                                        }}
                                                    />

                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group mt-2">
                                                    <label className="fw-bold">
                                                        Company Address <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        disabled={
                                                            lockExhibitorFields ||
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.address
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.address
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        placeholder="Address"
                                                        className="form-control my-2"
                                                        value={companyAddress}
                                                        onChange={(e) => {
                                                            setCompanyAddress(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        City <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="City"
                                                        className="form-control my-2"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.city
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.city
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={city}
                                                        onChange={(e) => {
                                                            handleCity(e);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        State <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="State"
                                                        className="form-control my-2"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.state
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.state
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={state}
                                                        onChange={(e) => {
                                                            setState(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        Country <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Country"
                                                        className="form-control my-2"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.state
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.state
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={country}
                                                        onChange={(e) => {
                                                            setCountry(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        Zip code <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Pincode"
                                                        className="form-control my-2"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.pincode
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.pincode
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={zip}
                                                        onChange={(e) => {
                                                            setZip(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 mb-3">
                                                    <label className="fw-bold">
                                                        Company Email <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={companyEmail}
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true"
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        placeholder="Company Email"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true"
                                                        }
                                                        className="form-control my-2"
                                                        onChange={(e) => handleCompanyEmailChange(e)}
                                                        onBlur={handleCompanyEmailBlur}
                                                    />
                                                    {CompanyEmailError && (
                                                        <p className="text-danger">
                                                            {CompanyEmailError}
                                                        </p>
                                                    )}


                                                </div>

                                                <div className="col-lg-6 col-12 mb-3">
                                                    <label className="fw-bold">
                                                        Company Number <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={companyNumber}
                                                        placeholder="Company Mobile"
                                                        className="form-control my-2"
                                                        onChange={handleCompanyNumberChange}
                                                    />
                                                    {CompanyNumberError === "true" && (
                                                        <p className="text-danger">
                                                            This Number is already registered.
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                    <label className="fw-bold">
                                                        Visiting Card <font color="#FF0000">*</font>
                                                    </label>
                                                    <CommonFileUploader
                                                        handlePhoto={handleVistingCard}
                                                        fileName={getFileNameDisplay(visitingCard)}
                                                        duplicateError={duplicateError}
                                                        accept=".jpg, .jpeg, .png"
                                                        loading={visitingCardLoading}
                                                    />
                                                    {visitingCard && (
                                                        <div style={styles.imageDiv}>
                                                            <img
                                                                src={getImagePreviewUrl(visitingCard)}
                                                                alt="Preview"
                                                                style={styles.previewImg}
                                                            />
                                                        </div>
                                                    )}


                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                    <label className="fw-bold">
                                                        Store Image<font color="#FF0000">*</font>
                                                    </label>
                                                    <CommonFileUploader
                                                        handlePhoto={handleStoreImage}
                                                        fileName={getFileNameDisplay(storeImage)}
                                                        duplicateError={duplicateError}
                                                        accept=".jpg, .jpeg, .png"
                                                        loading={storeImgLoading}
                                                    />
                                                    {storeImage && (
                                                        <div style={styles.imageDiv}>
                                                            <img
                                                                src={getImagePreviewUrl(storeImage)}
                                                                alt="Preview"
                                                                style={styles.previewImg}
                                                            />
                                                        </div>
                                                    )}
                                                    <p>Allowed only .png, .jpeg, .jpg</p>
                                                </div>

                                                <hr />

                                                <h3 className="mb-3">Which jewellery categories would you like to explore at the show? *</h3>

                                                <div className="row mb-3">
                                                    {categoriesList.map((cat, index) => (
                                                        <div className="col-6" key={index}>
                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    value={cat}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        setSelectedCategories((prev) =>
                                                                            prev.includes(value)
                                                                                ? prev.filter((c) => c !== value)
                                                                                : [...prev, value]
                                                                        );
                                                                    }}
                                                                />{" "}
                                                                {cat}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                                <hr />

                                                <h3 className="mb-3">Buyer Details</h3>
                                            </div>

                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Mobile No. <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={visitorMobileNo}
                                                    placeholder="Mobile"
                                                    className="form-control my-2"
                                                    onChange={handleVisitorMobileNoChange}
                                                />
                                                {(duplicateError === "true" || duplicateError === "vip") && (
                                                    <p className="text-danger">
                                                        This Mobile number is already registered
                                                    </p>
                                                )}
                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Email <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={visitorEmailId}
                                                    style={{
                                                        background: `${duplicateError === "vip" ||
                                                            duplicateError === "true"
                                                            ? "#cdcdcd"
                                                            : "#fff"
                                                            }`,
                                                    }}
                                                    placeholder="Email"
                                                    disabled={
                                                        duplicateError === "vip" ||
                                                        duplicateError === "true"
                                                    }
                                                    className="form-control my-2"
                                                    onChange={(e) => handleVisitorEmailChange(e)}
                                                    onBlur={handleVisitorEmailBlur}
                                                />
                                                {emailError && (
                                                    <p className="text-danger">
                                                        {emailError}
                                                    </p>
                                                )}
                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    First Name <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={visitorFirstName}
                                                    placeholder="First Name"
                                                    style={{
                                                        background: `${duplicateError === "vip" ||
                                                            duplicateError === "true"
                                                            ? "#cdcdcd"
                                                            : "#fff"
                                                            }`,
                                                    }}
                                                    disabled={
                                                        duplicateError === "vip" ||
                                                        duplicateError === "true"
                                                    }
                                                    className="form-control my-2"
                                                    onChange={(e) => {
                                                        handleFirstNameChange(e);
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Last Name <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={visitorLastName}
                                                    placeholder="Last Name"
                                                    style={{
                                                        background: `${duplicateError === "vip" ||
                                                            duplicateError === "true"
                                                            ? "#cdcdcd"
                                                            : "#fff"
                                                            }`,
                                                    }}
                                                    disabled={
                                                        duplicateError === "vip" ||
                                                        duplicateError === "true"
                                                    }
                                                    className="form-control my-2"
                                                    onChange={(e) => {
                                                        handleLastNameChange(e);
                                                    }}
                                                />
                                            </div>

                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Upload Pic <font color="#FF0000">*</font>
                                                </label>
                                                <CommonFileUploader
                                                    handlePhoto={handlePhoto}
                                                    fileName={getFileNameDisplay(photo)}
                                                    duplicateError={duplicateError}
                                                    accept=".jpg, .jpeg, .png"
                                                    loading={photoLoading}
                                                />
                                                {photo && (
                                                    <div style={styles.imageDiv}>
                                                        <img
                                                            src={getImagePreviewUrl(photo)}
                                                            alt="Preview"
                                                            style={styles.previewImg}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Upload ID Front <font color="#FF0000">*</font>
                                                </label>
                                                <CommonFileUploader
                                                    handlePhoto={handleIDFront}
                                                    fileName={getFileNameDisplay(idProofFront)}
                                                    duplicateError={duplicateError}
                                                    accept=".jpg, .jpeg, .png"
                                                    loading={idFrontLoading}
                                                />
                                                {idProofFront && (
                                                    <div style={styles.imageDiv}>
                                                        <img
                                                            src={getImagePreviewUrl(idProofFront)}
                                                            alt="Preview"
                                                            style={styles.previewImg}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                <label className="fw-bold">
                                                    Upload ID Back <font color="#FF0000">*</font>
                                                </label>
                                                <CommonFileUploader
                                                    handlePhoto={handleIDBack}
                                                    fileName={getFileNameDisplay(idProofBack)}
                                                    duplicateError={duplicateError}
                                                    accept=".jpg, .jpeg, .png"
                                                    loading={idBackLoading}
                                                />
                                                {idProofBack && (
                                                    <div style={styles.imageDiv}>
                                                        <img
                                                            src={getImagePreviewUrl(idProofBack)}
                                                            alt="Preview"
                                                            style={styles.previewImg}
                                                        />
                                                    </div>
                                                )}


                                            </div>
                                            <div className="col-12 form-group mb-3 mt-3">
                                                <Button
                                                    type="button"
                                                    className="regis w-100"
                                                    style={{ backgroundColor: "#fff" }}
                                                    onClick={handleSubmit}
                                                    disabled={
                                                        isLoading ||
                                                        duplicateError === "vip" ||
                                                        duplicateError === "true" ||
                                                        CompanyEmailError || emailError
                                                    }
                                                >
                                                    {isLoading ? (
                                                        <Spinner animation="border" size="sm" />
                                                    ) : (
                                                        "Register"
                                                    )}
                                                </Button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="container text-center my-5">
                                            <div className="card shadow-lg p-3 mb-5 bg-white rounded">
                                                <div className="card-body">
                                                    <h1 className="card-title text-danger">
                                                        Visitor Registration Closed
                                                    </h1>
                                                    <p className="card-text text-muted">
                                                        We apologize for the inconvenience. The visitor
                                                        registration is now closed.
                                                    </p>
                                                    {/* <div className="mt-4">
                                                        <a href="/" className="btn btn-success">
                                                            Go to Homepage
                                                        </a>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                        // <Spinner animation="border" size="sm" />
                                    )}

                                    {/* Submit Button */}
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewVisitorForm;
